import { Box } from '@mui/material';
import React from 'react';

export const Spacing64 = () => {
  return <Box sx={{ height: '64px', visibility: 'hidden' }}></Box>;
};
